import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as EditIcon } from '../../../assets/icons/pen.svg';
import TooltipComponent from '../bootstrap-component/tooltip-component';
import { getTranslatedText } from '../../../util/util';
import usePageTranslation from '../../../hooks/ui/usePageTranslation';

interface EditTranslationIconProps {
  translationKey: string;
  translationType?: string;
}

const EditTranslationIcon: React.FC<EditTranslationIconProps> = ({ translationKey, translationType }) => {
  const navigate = useNavigate();
  const PageTranslation = usePageTranslation();
  let translationTooltip: string;
  
  switch (translationType) {
    case 'text':
      translationTooltip = 'Edit text';
      break;
    case 'tooltip':
      translationTooltip = 'Edit tooltip';
      break;
    case 'placeholder':
      translationTooltip = 'Edit placeholder';
      break;
    case 'news':
      translationTooltip = 'Edit News';
      break;
    default:
      translationTooltip = 'Edit ' + translationKey; 
  }

  return (
    <>
    <TooltipComponent title={translationTooltip}>
      <EditIcon className='bc-icon me-1 cursor-pointer' 
        aria-label={getTranslatedText('imageAlt.text', PageTranslation)}
        onClick={() => {
          navigate('/app/admin/manageTranslation', { state: { passedTranslationKey: translationKey } });
        }} 
      />
      {/* <img
        src={Edit}
        alt= {getTranslatedText('imageAlt.text', PageTranslation)}
        className="editIconSize cursor-pointer"
        onClick={() => {
          navigate('/app/admin/manageTranslation', { state: { passedTranslationKey: translationKey } });
        }}
      /> */}
    </TooltipComponent>
    </>
  );
};

export default EditTranslationIcon;